export default {
  apiKey: 'AIzaSyDefRL4vG-M8O2GHrAvlOwlw3KUgQYa-vg',
  authDomain: 'hocus-focus-production.firebaseapp.com',
  databaseURL: 'https://hocus-focus-production.firebaseio.com',
  projectId: 'hocus-focus-production',
  storageBucket: 'hocus-focus-production.appspot.com',
  messagingSenderId: '1058982632883',
  appId: '1:1058982632883:web:d579b5bae3af6c8c',
  measurementId: 'G-M2FFKMZE3T',
};
